import type { Point } from './shape'

/**
 * Drop custom body icons here.
 *
 * Use them with `<LosiBot icon="your-id" />` or
 * `<LosiLoader variant="glyph" icon="…" />` — the body morphs only when that
 * prop changes.
 *
 * Prefer **bars** (same family as the measured "!") for crisp glyphs.
 * `discs` make soft blobs — fine for clouds, bad for letters.
 *
 * Pick ONE geometry source per entry:
 * - `bars` — several capsules merged (best for + ? & -like strokes)
 * - `bar` — one capsule / frustum
 * - `polygon` — closed outline in ball-radius units
 * - `discs` — union of circles (soft / blobby)
 * - `radii` — raw `PROFILE_SAMPLES` (64) floats, auto-normalised
 *
 * Optional `dot` = detached disc under the glyph; `dotPath` = SVG path like the
 * alert teardrop (`ALERT_TEAR_PATH` from `./icons`).
 */

export interface CustomIconDraft {
  id: string
  bars?: Array<{
    x1: number
    y1: number
    r1: number
    x2: number
    y2: number
    r2: number
    cy?: number
  }>
  bar?: {
    x1: number
    y1: number
    r1: number
    x2: number
    y2: number
    r2: number
    cy?: number
  }
  discs?: Array<{ x: number; y: number; r: number }>
  polygon?: Point[]
  polyCx?: number
  polyCy?: number
  /** Length must be `PROFILE_SAMPLES` (64). */
  radii?: number[]
  cy?: number
  dot?: { x: number; y: number; r: number }
  dotPath?: string
}

/**
 * ↓ Add your icons below.
 *
 * @example crisp plus
 * { id: 'cross', bars: [
 *   { x1: 0, y1: -0.5, r1: 0.11, x2: 0, y2: 0.5, r2: 0.11 },
 *   { x1: -0.5, y1: 0, r1: 0.11, x2: 0.5, y2: 0, r2: 0.11 }
 * ]}
 *
 * @example single stem + dot (exclamation-style)
 * { id: 'tall', bar: { x1: 0, y1: -0.5, r1: 0.14, x2: 0, y2: 0.15, r2: 0.08, cy: -0.18 },
 *   dot: { x: 0, y: 0.55, r: 0.12 } }
 */
export const CUSTOM_ICONS: CustomIconDraft[] = [
  // {
  //   id: 'cross',
  //   bars: [
  //     { x1: 0, y1: -0.5, r1: 0.11, x2: 0, y2: 0.5, r2: 0.11 },
  //     { x1: -0.5, y1: 0, r1: 0.11, x2: 0.5, y2: 0, r2: 0.11 }
  //   ]
  // }
]
